import "./index.css"
import { useGlobal } from "../../../../context/global"
import { useEffect, useState } from "react"
import PageLoader from "../../../../components/info/pageloader"
import Seva from "./seva"
import ApprovalPendingPage from "./applicant"

const VolunteerHome = () => {

    const { auth, api } = useGlobal()
    const { user } = auth

    var [sevaData, setSevaData] = useState()
    var [approval, setApproval] = useState()

    useEffect(() => {
        api.call('/get-volunteer-home-data', user).then(({ data }) => {
            setApproval(data.approval)
            setSevaData(data.sevaData.filter(seva => seva.maleOnly ? (user.gender || seva.isServiceListReady) : true))
        })
    }, [])

    const showSeva = sevaData !== undefined ? !!(sevaData.length && approval != 'withheld') : false

    return (
        sevaData !== undefined ?
            ['approved', 'withheld', 'archived'].includes(approval) ?
                <div className="volhome-main flex-col">
                    {showSeva ? <div className="volhome-upcoming">Upcoming Sevas</div> : null}
                    {showSeva ?
                        <div className="felx-col">{sevaData.map(seva => <Seva key={seva.id} seva={seva} user={user} />)}</div>
                        :
                        <div>No upcoming sevas found!</div>}
                </div> : <ApprovalPendingPage />
            : <PageLoader text={"Loading..."} />
    )
}

export default VolunteerHome